import React from 'react';
import { Flex, Tooltip, Button, Typography } from 'antd';
import Icon from '@mdi/react';
import Ninja from '@ninja';
import { mdiFilter } from '@mdi/js';

const { Text } = Typography;

const CrmFilterableField = ({ value, filterKey, onFilter, icon }) => {
  if (!value)
    return (
      <Text type='secondary' className='text-sm '>
        Not provided
      </Text>
    );

  return (
    <Flex align='center'>
      <Tooltip title={`Filter by ${filterKey}`}>
        <Button
          shape='circle'
          size='small'
          type='text'
          onClick={() => onFilter(filterKey, value)}
          icon={<Icon path={mdiFilter} color={Ninja.colors.medium} size={0.6} />}
        />
      </Tooltip>
      {icon && <Icon path={icon} size={0.7} color={Ninja.colors.medium} />}
      <Text strong className='text-sm'>
        {value}
      </Text>
    </Flex>
  );
};

export default CrmFilterableField;
